/**
 * CoureHub.ServiceOwner.Mgt
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateServiceOwnerRequestDto } from '../model/createServiceOwnerRequestDto';
import { ServiceOwnerTblGenericListResponseDto } from '../model/serviceOwnerTblGenericListResponseDto';
import { ServiceOwnerTblGenericResponseDto } from '../model/serviceOwnerTblGenericResponseDto';
import { ServiceOwnerUpdate } from '../model/serviceOwnerUpdate';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceOwnerService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerCreateServiceOwnerPost(body?: CreateServiceOwnerRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerTblGenericResponseDto>;
    public apiServiceOwnerCreateServiceOwnerPost(body?: CreateServiceOwnerRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerCreateServiceOwnerPost(body?: CreateServiceOwnerRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerCreateServiceOwnerPost(body?: CreateServiceOwnerRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServiceOwnerTblGenericResponseDto>('post',`${this.basePath}/api/ServiceOwner/CreateServiceOwner`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param serviceproviderID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerGetAllServiceOwnerGet(id?: string, serviceproviderID?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerTblGenericListResponseDto>;
    public apiServiceOwnerGetAllServiceOwnerGet(id?: string, serviceproviderID?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerTblGenericListResponseDto>>;
    public apiServiceOwnerGetAllServiceOwnerGet(id?: string, serviceproviderID?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerTblGenericListResponseDto>>;
    public apiServiceOwnerGetAllServiceOwnerGet(id?: string, serviceproviderID?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (serviceproviderID !== undefined && serviceproviderID !== null) {
            queryParameters = queryParameters.set('ServiceproviderID', <any>serviceproviderID);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceOwnerTblGenericListResponseDto>('get',`${this.basePath}/api/ServiceOwner/GetAllServiceOwner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerGetServiceOwnerIdGet(id: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerTblGenericResponseDto>;
    public apiServiceOwnerGetServiceOwnerIdGet(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerGetServiceOwnerIdGet(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerGetServiceOwnerIdGet(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiServiceOwnerGetServiceOwnerIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceOwnerTblGenericResponseDto>('get',`${this.basePath}/api/ServiceOwner/GetServiceOwner/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceOwnerUpdateServiceOwnerPut(body?: ServiceOwnerUpdate, observe?: 'body', reportProgress?: boolean): Observable<ServiceOwnerTblGenericResponseDto>;
    public apiServiceOwnerUpdateServiceOwnerPut(body?: ServiceOwnerUpdate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerUpdateServiceOwnerPut(body?: ServiceOwnerUpdate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceOwnerTblGenericResponseDto>>;
    public apiServiceOwnerUpdateServiceOwnerPut(body?: ServiceOwnerUpdate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ServiceOwnerTblGenericResponseDto>('put',`${this.basePath}/api/ServiceOwner/UpdateServiceOwner`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
